import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import {debounceTime, Subject, Subscription} from "rxjs";
import {USER_PROFILE_DASHBOARD_ROUTE} from 'src/app/app-routing.module';
import {environment} from "@environment";
import {AbstractComponent, CurrentItemType} from "@components";
import {EventItem, EventItemType, League, Lookups} from "@model";
import {ActionService, AuthenticationService, EventService, LeagueService, PublicEventsService} from "@services";

@Component({
  selector: 'app-league-details',
  templateUrl: './league-details.component.html',
  styleUrls: ['./league-details.component.scss']
})
export class LeagueDetailsComponent extends AbstractComponent implements OnInit {
  @Input({required: true}) league?: League;
  @Input({required: true}) countries: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  private addToFavoritesButtonSubject = new Subject<EventItem | undefined>();

  constructor(
    private leagueService: LeagueService,
    private eventService: EventService,
    public translocoService: TranslocoService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private publicEventsService: PublicEventsService,
    private actionService: ActionService
  ) {
    super();
  }

  ngOnInit(): void {
    this.leagueService.setCurrentLeague(this.league);
    this.subscriptions.push(this.subscribeToAddToFavoritesButton());
  }

  subscribeToAddToFavoritesButton(): Subscription {
    return this.addToFavoritesButtonSubject.pipe(debounceTime(environment.debounceActionInterval)).subscribe(eventItem => {
      if (this.authenticationService.isAuthenticated()) {
        this.addToFavoritesAction(eventItem);
      } else {
        this.actionService.addAction(() => this.addToFavoritesAction(eventItem));
        this.actionService.addAction(() => this.router.navigate([USER_PROFILE_DASHBOARD_ROUTE], {queryParams: {typeOfRace: EventItemType.MY_FAVORITE}}));
      }
    });
  }

  addToFavoritesAction(eventItem?: EventItem): void {
    if (eventItem?.id) {
      const action = eventItem.favorite
        ? this.publicEventsService.removeEventFromFavorites(eventItem.id!)
        : this.publicEventsService.addEventToFavorites(eventItem.id!);

      action.subscribe(actionResult => {
        if (actionResult.result) {
          this.publicEventsService.fetchUserFavoritesEvent();
          eventItem.favorite = !eventItem.favorite;
        }
      });
    }
  }

  protected readonly CurrentItemType = CurrentItemType;
}
